var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"hidden","name":"authenticity_token"},domProps:{"value":_vm.csrfToken}})
}
var staticRenderFns = []

export { render, staticRenderFns }